export const styles = {
  wrapper: {
    padding: '0px 30px 70px',
    display: 'flex',
    flexDirection: 'column',

    '& > button': {
      width: '100px',
      alignSelf: 'flex-end',
      marginTop: '10px',
    },
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '30px',
  },
  dropzone: {
    marginTop: '20px',
    '& > div:nth-child(2)': {
      width: '100%',
    },
  },
}
